module.exports = __webpack_public_path__ + "static/media/TikTok_Chin_iOS.790efa7d.docx";